














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import projectsRepository from '@/services/projectsRepository';

@Component({
  components: {

  },
})
export default class ProjectsStats extends Vue {
    private loading: boolean = false;
    private stats: IProjectStats | null = null;

    public async mounted() {
        try {
            this.loading = true;
            this.stats = (await projectsRepository.getStats()).data;
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.loading = false;
        }
    }

    public showProjects(sort: string) {
        this.$router.push({ name: 'projectsOverview', query: { sort } });
    }
}
